import styled from '@emotion/styled';

export const StyledContainer = styled.div(() => ({
    position: 'relative',
}));
